
import ViewBox from 'vux/src/components/view-box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import './refresh-init.js'
import store from './vuex/store'
import dsBridge from 'dsbridge'

/* eslint-disable */

const FastClick = require('fastclick')
var str = navigator.userAgent.toLowerCase();
var ver = str.match(/cpu iphone os (.*?) like mac os/);
if (!ver) { // 非IOS系統

FastClick.attach(document.body)
} else {
console.log("你當前的Ios系統版本為：" + ver[1].replace(/_/g, "."));
if (parseInt(ver[1]) >= 11) {

} else {

FastClick.attach(document.body)
}
}

export default {
name: 'App',
components: {
ViewBox, Alert, Loading
},
async created () {
let me = this













dsBridge.call('getBaseInfo', function (res) {
let RES = JSON.parse(res)
if (RES) {
me.hideTile = true
}
})




},
mounted () {
let me = this

store.watch(function (state) {
return state.isLoading
}, function (e) {
me.isLoadingStatus = e
}, {
immediate: true
})


store.watch(function (state) {
return state.globalAlertStatus
}, function (e) {
me.alertStatus = e
}, {
immediate: true
})


store.watch(function (state) {
return state.globalAlertText
}, function (e) {
me.alertText = e
}, {
immediate: true
})


store.watch(function (state) {
return state.leftOptions
}, function (e) {
me.leftOptions = e
dsBridge.call('setTabBarLeft', e.showBack ? '1' : '0')
}, {
immediate: true
})


store.watch(function (state) {
return state.title
}, function (e) {
me.title = e
dsBridge.call('setTabBarTitle', e)
}, {
immediate: true
})
},
watch: {
alertStatus (data) {
store.commit('setGlobalAlertStatus', data)
},
'$route' (to, from) {
const toDepth = to.path.split('/').length
const fromDepth = from.path.split('/').length

}
},
data () {
return {
isLoadingStatus: false,
alertStatus: '',
alertText: store.state.globalAlertText,
leftOptions: {},
title: '',
transitionName: '',
hideTile: false
}
},
methods: {







}
}



// WEBPACK FOOTER //
// ./src/App.vue